
import { v4 as uuidv4 } from "uuid";
import { ModelBase } from "@models/UpsertableBase";
import { 
  // Spell,
  TableEntry
} from "@dndModels/misc";
import { CREATURE_CRS } from "@dndModels/Constants";

// import { DandDCharacterUtilitiesClass } from "../../utilities/character_utilities_class";
import CommonUtilities from "@utilities/common_utilities";
import { SKILLS } from "@dndModels/constantized";
import { DamageType, DataType } from "@dndModels/Types";
// import DandDAPI from "../../utilities/system_api";

/**
 * This is how I make the table of spell slots for
 * the various magical classes/subclasses.
 * 
 */

// const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();

export interface TableBase {
  entries: TableEntry[];
  fields: string[];
  field_order: { [position: number]: string };
  getEntry: (level: number) => TableEntry | undefined;
  entryString: (entry: TableEntry) => string;
  entryStringForLevel: (level: number) => string;
  entryData: (level: number) => { [field: string]: number };
  entryField: (level: number, field: string) => number;
  extrapolateEmptyFields: () => void;
}

const extrapolate = (table: TableBase) => {
  let level_options = [...CREATURE_CRS];
  level_options = level_options.filter(o => table.entries.filter(o2 => `${o2.level}` === o).length === 0);
  const entry_levels = table.entries.map(o => o.level);
  const min = entry_levels.length === 0 ? 0 : Math.min(...entry_levels);
  const max = entry_levels.length === 0 ? 0 : Math.max(...entry_levels);
  const empty_entries = level_options.map(o => +o).filter(o => o > min && o < max);
  const fields = table.fields;
  // Identify blocks of empty entries
  let use_empty_entries = [...empty_entries];
  let min_empty = Math.min(...use_empty_entries);
  let level_before = Math.max(...entry_levels.filter(o => o < min_empty));
  let level_after = Math.min(...entry_levels.filter(o => o > level_before));
  let before = table.entries.find(o => o.level === level_before);
  let after = table.entries.find(o => o.level === level_after);
  while (before && after) {
    // console.log(before);
    // console.log(after);
     
    let block_empty_entries = [...use_empty_entries.filter(o => o < level_after)];
    const level_diff = level_after - level_before;
    const diff_for_fields: { [field: string]: { total: number, avg: number, remainder: number, remainder_offset: number, applied_at_level: { [level: number]: number }, remainder_levels: number[] } } = {};
    let total_diff = 0;
    for (const field of fields) {
      const diff = after.data[field] - before.data[field];
      diff_for_fields[field] = { 
        total: diff, 
        avg: Math.floor(diff / level_diff), // Every level should have at least this many points increased
        remainder: diff % level_diff, // Some levels will need additional points increased, totalling this many.  These should be evenly distributed across the levels.
        remainder_offset: 0,
        applied_at_level: {},
        remainder_levels: []
      };
      diff_for_fields[field].remainder_offset = diff_for_fields[field].remainder / level_diff;
      total_diff += diff;
    }
    const avg_diff = Math.floor(total_diff / level_diff); // Every level should have at least this many points increased
    const remainder = total_diff % level_diff; // Some levels will need additional points increased, totalling this many.  These should be evenly distributed across the levels.
    const remainder_offset = remainder / level_diff;
    const applied_at_level: { [level: number]: number } = {};
    const remainder_levels: number[] = [];
    let next_level = block_empty_entries[0];
    let previous = before;
    while (next_level) {
      const new_levels = next_level - level_before;
      const new_entry = new TableEntry();
      new_entry.level = next_level;
      applied_at_level[next_level] = 0;
      for (const field of fields) {
        const increase_by = diff_for_fields[field].avg;
        new_entry.data[field] = previous.data[field] + increase_by;
        diff_for_fields[field].applied_at_level[next_level] = increase_by;
        applied_at_level[next_level] += increase_by;
      }
      // Sort the fields so the ones that need to do remainders most come first.

      // console.log(fields.map(a => {
      //   const usable_remainders_a = new_levels * diff_for_fields[a].remainder_offset;
      //   const used_remainders_a = diff_for_fields[a].remainder_levels.length;
      //   const diff_a = usable_remainders_a - used_remainders_a;
        
      //   return `${a}: ${diff_a}`;
      // }));
      const sorted_fields = fields.sort((a, b) => {
        const usable_remainders_a = new_levels * diff_for_fields[a].remainder_offset;
        const used_remainders_a = diff_for_fields[a].remainder_levels.length;
        const diff_a = usable_remainders_a - used_remainders_a;
        
        const usable_remainders_b = new_levels * diff_for_fields[b].remainder_offset;
        const used_remainders_b = diff_for_fields[b].remainder_levels.length;
        const diff_b = usable_remainders_b - used_remainders_b;

        if (diff_a >= diff_b) {
          return -1;
        } else {
          return 1;
        }
      }); // common_util.shuffleList(fields);
      // console.log(sorted_fields);
      console.log("Next Level: " + next_level);
      console.log("Avg Diff: " + avg_diff);
      while (applied_at_level[next_level] < avg_diff) {
        console.log(applied_at_level[next_level]);
        const before = applied_at_level[next_level];
        for (const field of sorted_fields) {
          console.log(field);

          const field_remainder = diff_for_fields[field].remainder;
          if (field_remainder > diff_for_fields[field].remainder_levels.length) { // If this is false then this field has used all its remainders
            const usable_remainders = Math.ceil(new_levels * diff_for_fields[field].remainder_offset); // We don't want to get more than 1 ahead
            const used_remainders = diff_for_fields[field].remainder_levels.length;
            if (usable_remainders > used_remainders) {
              console.log("We can do a remainder");
              new_entry.data[field] += 1;
              diff_for_fields[field].applied_at_level[next_level] += 1;
              diff_for_fields[field].remainder_levels.push(next_level);
              applied_at_level[next_level] += 1;
            } else {
              console.log("Nope, check the next field");
            }
          } else {
            console.log("No Remainders");
          }
          
          if (applied_at_level[next_level] === avg_diff) {
            break; 
          }
        }
        if (applied_at_level[next_level] === before) { // Prevent infinite loop
          break;
        }
      }
      if (true) {
        // We've reached the normal amount for this level, check if we can do an extra remainder
        const usable_remainders = Math.floor(new_levels * remainder_offset);
        const used_remainders = remainder_levels.length;
        if (usable_remainders > used_remainders) {
          // We can do an extra remainder
          for (const field of sorted_fields) {
            // console.log(field);

            const field_remainder = diff_for_fields[field].remainder;
            if (field_remainder > diff_for_fields[field].remainder_levels.length) { // If this is false then this field has used all its remainders
              const usable_remainders = Math.ceil(new_levels * diff_for_fields[field].remainder_offset); // We don't want to get more than 1 ahead
              const used_remainders = diff_for_fields[field].remainder_levels.length;
              if (usable_remainders > used_remainders) {
                // We can do a remainder
                new_entry.data[field] += 1;
                diff_for_fields[field].applied_at_level[next_level] += 1;
                diff_for_fields[field].remainder_levels.push(next_level);
                remainder_levels.push(next_level);
                applied_at_level[next_level] += 1;
                break;
              } else {
                // Nope, check the next field
              }
            }
          }
        } 
      }
      block_empty_entries = block_empty_entries.slice(1);
      use_empty_entries = use_empty_entries.slice(1);
      next_level = block_empty_entries[0];
      table.entries.push(new_entry);
      previous = new_entry;
    }
    
    min_empty = Math.min(...use_empty_entries); 
    level_before = Math.max(...entry_levels.filter(o => o < min_empty)); 
    level_after = Math.min(...entry_levels.filter(o => o > level_before)); 
    before = table.entries.find(o => o.level === level_before); 
    after = table.entries.find(o => o.level === level_after);
  }
}

export class Table extends ModelBase implements TableBase {
  data_type: DataType = "table";
  type: DataType | "" = "";
  for_id = "";
  entries: TableEntry[] = [];
  field_order: { [position: number]: string } = {};
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.type = obj.type ? obj.type : "game_class";
      this.for_id = obj.for_id ? obj.for_id : "";
      this.entries = [];
      if (obj.entries) {
        obj.entries.forEach((entry: any) => {
          this.entries.push(new TableEntry(entry));
        });
      }
      this.field_order = obj.field_order ? obj.field_order : {};
      if (Object.keys(this.field_order).length === 0 && this.entries.length > 0) {
        const fields = Object.keys(this.entries[0].data);
        for (let i = 0; i < fields.length; ++i) {
          this.field_order[i] = fields[i];
        }
      }
    }
  }

  get_detail_format() {
    const str = `${super.get_detail_format()}; ${this.type}`;
    return str.trim();
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type = obj.type ? obj.type : "game_class";
  //     this.for_id = obj.for_id ? obj.for_id : "";
  //     this.entries = [];
  //     if (obj.entries) {
  //       obj.entries.forEach((entry: any) => {
  //         this.entries.push(new TableEntry(entry));
  //       });
  //     }
  //     this.field_order = obj.field_order ? obj.field_order : {};
  //     if (Object.keys(this.field_order).length === 0 && this.entries.length > 0) {
  //       const fields = Object.keys(this.entries[0].data);
  //       for (let i = 0; i < fields.length; ++i) {
  //         this.field_order[i] = fields[i];
  //       }
  //     }
  //   }
  // }

  get fields(): string[] {
    return Object.keys(this.field_order).map(o => +o).sort().map(o => this.field_order[o]);
  }
  getEntry(level: number) {
    let entry = this.entries.find(o => o.level === level);
    if (!entry) {
      // Get the highest one that is below level.
      const max = Math.max(...this.entries.filter(o => o.level < level).map(o => o.level),0);
      entry = this.entries.find(o => o.level === max);
    }
    return entry;
  }
  entryString(entry: TableEntry) {
    let str = "{ ";

    str += Object.keys(this.field_order).map(o => +o).sort().map(pos => {
      const field = this.field_order[pos];
      if (entry.data[field]) {
        return `${field}: ${entry.data[field]}`;
      } else {
        return `${field}: 0`;
      }
    }).join(", ");
    str += " }";
    return str;
  }
  entryStringForLevel(level: number) {
    const entry = this.getEntry(level);
    if (entry) {
      return this.entryString(entry);
    }
    return "{ }";
  }
  entryData(level: number) {
    const obj: { [field: string]: number } = {};
    const entry = this.getEntry(level);
    if (entry) {
      for (const pos of Object.keys(this.field_order).map(o => +o).sort()) {
        const field = this.field_order[pos];
        obj[field] = entry.data[field];
      }
    }
    return obj;
  }
  entryField(level: number, field: string) {
    let num = 0;
    const entry = this.getEntry(level);
    if (entry) {
      num = entry.data[field];
    }
    return num;
  }
  extrapolateEmptyFields() {
    extrapolate(this);
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      type: this.type,
      for_id: this.for_id,
      entries: this.entries.map(o => o.toDBObj()),
      field_order: this.field_order
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      type: this.type,
      for_id: this.for_id,
    };
  }

  copy(copyMe: Table, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.type = copyMe.type;
    this.for_id = copyMe.for_id;
    this.copyBase(copyMe);
  }

  copyBase(copyMe: TableBase): void {
    this.entries = copyMe.entries.map(o => o.clone());
    this.field_order = {...copyMe.field_order};
  }

  clone(drop_ids = false): Table {
    const new_obj = new Table();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class AttachedTable implements TableBase {
  entries: TableEntry[] = [];
  field_order: { [position: number]: string } = {};
  
  constructor(obj?: any) {
    if (obj) {
      this.entries = [];
      if (obj.entries) {
        obj.entries.forEach((entry: any) => {
          this.entries.push(new TableEntry(entry));
        });
      }
      this.field_order = obj.field_order ? obj.field_order : {};
      if (Object.keys(this.field_order).length === 0 && this.entries.length > 0) {
        const fields = Object.keys(this.entries[0].data);
        for (let i = 0; i < fields.length; ++i) {
          this.field_order[i] = fields[i];
        }
      }
    }
  }

  get fields(): string[] {
    return Object.keys(this.field_order).map(o => +o).sort().map(o => this.field_order[o]);
  }
  getEntry(level: number) {
    let entry = this.entries.find(o => o.level === level);
    if (!entry) {
      // Get the highest one that is below level.
      const max = Math.max(...this.entries.filter(o => o.level < level).map(o => o.level),0);
      entry = this.entries.find(o => o.level === max);
    }
    return entry;
  }
  entryString(entry: TableEntry) {
    let str = "{ ";

    str += Object.keys(this.field_order).map(o => +o).sort().map(pos => {
      const field = this.field_order[pos];
      if (entry.data[field]) {
        return `${field}: ${entry.data[field]}`;
      } else {
        return `${field}: 0`;
      }
    }).join(", ");
    str += " }";
    return str;
  }
  entryStringForLevel(level: number) {
    const entry = this.getEntry(level);
    if (entry) {
      return this.entryString(entry);
    }
    return "{ }";
  }
  entryData(level: number) {
    const obj: { [field: string]: number } = {};
    const entry = this.getEntry(level);
    if (entry) {
      for (const pos of Object.keys(this.field_order).map(o => +o).sort()) {
        const field = this.field_order[pos];
        obj[field] = entry.data[field];
      }
    }
    return obj;
  }
  entryField(level: number, field: string) {
    let num = 0;
    const entry = this.getEntry(level);
    if (entry) {
      num = entry.data[field];
    }
    return num;
  }
  extrapolateEmptyFields() {
    extrapolate(this);
  }

  toDBObj(): any {
    return {
      entries: this.entries.map(o => o.toDBObj()),
      field_order: this.field_order
    };
  }

  copy(copyMe: AttachedTable, drop_ids = false): void {
    this.copyBase(copyMe);
  }

  copyBase(copyMe: TableBase): void {
    this.entries = copyMe.entries.map(o => o.clone());
    this.field_order = {...copyMe.field_order};
  }

  clone(drop_ids = false): AttachedTable {
    const new_obj = new AttachedTable();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class LegendariesTable {
  entries: Legendaries[] = [];
  res_desc = "";
  act_desc = "";
  
  constructor(obj?: any) {
    if (obj) {
      this.entries = [];
      if (obj.entries) {
        obj.entries.forEach((entry: any) => {
          this.entries.push(new Legendaries(entry));
        });
      }
      this.res_desc = obj.res_desc ? obj.res_desc : "";
      this.act_desc = obj.act_desc ? obj.act_desc : "";
    }
  }

  getEntry(level: number) {
    let entry = this.entries.find(o => o.level === level);
    if (!entry) {
      // Get the highest one that is below level.
      const max = Math.max(...this.entries.filter(o => o.level < level).map(o => o.level),0);
      entry = this.entries.find(o => o.level === max);
    }
    return entry;
  }

  toDBObj(): any {
    return {
      entries: this.entries.map(o => o.toDBObj()),
      res_desc: this.res_desc,
      act_desc: this.act_desc,
    };
  }

  copy(copyMe: LegendariesTable): void {
    this.entries = copyMe.entries.map(o => o.clone());
    this.res_desc = copyMe.res_desc;
    this.act_desc = copyMe.act_desc;
  }

  clone(): LegendariesTable {
    const new_obj = new LegendariesTable();
    new_obj.copy(this);
    return new_obj;
  }

  extrapolateEmptyFields() {
    let level_options = [...CREATURE_CRS];
    level_options = level_options.filter(o => this.entries.filter(o2 => `${o2.level}` === o).length === 0);
    const entry_levels = this.entries.map(o => o.level);
    const min = entry_levels.length === 0 ? 0 : Math.min(...entry_levels);
    const max = entry_levels.length === 0 ? 0 : Math.max(...entry_levels);
    const empty_entries = level_options.map(o => +o).filter(o => o > min && o < max);
    const fields: ("actions" | "act_lair" | "resistances" | "res_lair")[] = ["actions","act_lair","resistances","res_lair"]
    // Identify blocks of empty entries
    let use_empty_entries = [...empty_entries];
    let min_empty = Math.min(...use_empty_entries);
    let level_before = Math.max(...entry_levels.filter(o => o < min_empty));
    let level_after = Math.min(...entry_levels.filter(o => o > level_before));
    let before = this.entries.find(o => o.level === level_before);
    let after = this.entries.find(o => o.level === level_after);
    while (before && after) {
      // console.log(before);
      // console.log(after);
       
      let block_empty_entries = [...use_empty_entries.filter(o => o < level_after)];
      const level_diff = level_after - level_before;
      const diff_for_fields: { [field: string]: { total: number, avg: number, remainder: number, remainder_offset: number, applied_at_level: { [level: number]: number }, remainder_levels: number[] } } = {};
      let total_diff = 0;
      for (const field of fields) {
        const diff = after[field] - before[field];
        diff_for_fields[field] = { 
          total: diff, 
          avg: Math.floor(diff / level_diff), // Every level should have at least this many points increased
          remainder: diff % level_diff, // Some levels will need additional points increased, totalling this many.  These should be evenly distributed across the levels.
          remainder_offset: 0,
          applied_at_level: {},
          remainder_levels: []
        };
        diff_for_fields[field].remainder_offset = diff_for_fields[field].remainder / level_diff;
        total_diff += diff;
      }
      const avg_diff = Math.floor(total_diff / level_diff); // Every level should have at least this many points increased
      const remainder = total_diff % level_diff; // Some levels will need additional points increased, totalling this many.  These should be evenly distributed across the levels.
      const remainder_offset = remainder / level_diff;
      const applied_at_level: { [level: number]: number } = {};
      const remainder_levels: number[] = [];
      let next_level = block_empty_entries[0];
      let previous = before;
      while (next_level) {
        const new_levels = next_level - level_before;
        const new_entry = new Legendaries();
        new_entry.level = next_level;
        applied_at_level[next_level] = 0;
        for (const field of fields) {
          const increase_by = diff_for_fields[field].avg;
          new_entry[field] = previous[field] + increase_by;
          diff_for_fields[field].applied_at_level[next_level] = increase_by;
          applied_at_level[next_level] += increase_by;
        }
        // Sort the fields so the ones that need to do remainders most come first.
  
        // console.log(fields.map(a => {
        //   const usable_remainders_a = new_levels * diff_for_fields[a].remainder_offset;
        //   const used_remainders_a = diff_for_fields[a].remainder_levels.length;
        //   const diff_a = usable_remainders_a - used_remainders_a;
          
        //   return `${a}: ${diff_a}`;
        // }));
        const sorted_fields = fields.sort((a, b) => {
          const usable_remainders_a = new_levels * diff_for_fields[a].remainder_offset;
          const used_remainders_a = diff_for_fields[a].remainder_levels.length;
          const diff_a = usable_remainders_a - used_remainders_a;
          
          const usable_remainders_b = new_levels * diff_for_fields[b].remainder_offset;
          const used_remainders_b = diff_for_fields[b].remainder_levels.length;
          const diff_b = usable_remainders_b - used_remainders_b;
  
          if (diff_a >= diff_b) {
            return -1;
          } else {
            return 1;
          }
        }); // common_util.shuffleList(fields);
        // console.log(sorted_fields);
        console.log("Next Level: " + next_level);
        console.log("Avg Diff: " + avg_diff);
        while (applied_at_level[next_level] < avg_diff) {
          console.log(applied_at_level[next_level]);
          const before = applied_at_level[next_level];
          for (const field of sorted_fields) {
            console.log(field);
  
            const field_remainder = diff_for_fields[field].remainder;
            if (field_remainder > diff_for_fields[field].remainder_levels.length) { // If this is false then this field has used all its remainders
              const usable_remainders = Math.ceil(new_levels * diff_for_fields[field].remainder_offset); // We don't want to get more than 1 ahead
              const used_remainders = diff_for_fields[field].remainder_levels.length;
              if (usable_remainders > used_remainders) {
                console.log("We can do a remainder");
                new_entry[field] += 1;
                diff_for_fields[field].applied_at_level[next_level] += 1;
                diff_for_fields[field].remainder_levels.push(next_level);
                applied_at_level[next_level] += 1;
              } else {
                console.log("Nope, check the next field");
              }
            } else {
              console.log("No Remainders");
            }
            
            if (applied_at_level[next_level] === avg_diff) {
              break; 
            }
          }
          if (applied_at_level[next_level] === before) { // Prevent infinite loop
            break;
          }
        }
        if (true) {
          // We've reached the normal amount for this level, check if we can do an extra remainder
          const usable_remainders = Math.floor(new_levels * remainder_offset);
          const used_remainders = remainder_levels.length;
          if (usable_remainders > used_remainders) {
            // We can do an extra remainder
            for (const field of sorted_fields) {
              // console.log(field);
  
              const field_remainder = diff_for_fields[field].remainder;
              if (field_remainder > diff_for_fields[field].remainder_levels.length) { // If this is false then this field has used all its remainders
                const usable_remainders = Math.ceil(new_levels * diff_for_fields[field].remainder_offset); // We don't want to get more than 1 ahead
                const used_remainders = diff_for_fields[field].remainder_levels.length;
                if (usable_remainders > used_remainders) {
                  // We can do a remainder
                  new_entry[field] += 1;
                  diff_for_fields[field].applied_at_level[next_level] += 1;
                  diff_for_fields[field].remainder_levels.push(next_level);
                  remainder_levels.push(next_level);
                  applied_at_level[next_level] += 1;
                  break;
                } else {
                  // Nope, check the next field
                }
              }
            }
          } 
        }
        block_empty_entries = block_empty_entries.slice(1);
        use_empty_entries = use_empty_entries.slice(1);
        next_level = block_empty_entries[0];
        this.entries.push(new_entry);
        previous = new_entry;
      }
      
      min_empty = Math.min(...use_empty_entries); 
      level_before = Math.max(...entry_levels.filter(o => o < min_empty)); 
      level_after = Math.min(...entry_levels.filter(o => o > level_before)); 
      before = this.entries.find(o => o.level === level_before); 
      after = this.entries.find(o => o.level === level_after);
    }
  }
}

export class Legendaries { 
  true_id = "";
  level = 0;
  resistances = 0;
  res_lair = 0;
  // res_desc: string = "";
  actions = 0;
  act_lair = 0;
  // act_desc: string = "";
  lair_actions_extra = "";
  
  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.level = obj.level ? obj.level : 0;
      this.resistances = obj.resistances ? obj.resistances : 0;
      this.res_lair = obj.res_lair ? obj.res_lair : 0;
      // this.res_desc = obj.res_desc ? obj.res_desc : "";
      this.actions = obj.actions ? obj.actions : 0;
      this.act_lair = obj.act_lair ? obj.act_lair : 0;
      // this.act_desc = obj.act_desc ? obj.act_desc : "";
      if (this.resistances === 0 && obj.data) {
        this.resistances = obj.data["Legendary Resistances"] !== undefined ? obj.data["Legendary Resistances"] : 0;
      }
      if (this.actions === 0 && obj.data) {
        this.actions = obj.data["Legendary Actions"] !== undefined ? obj.data["Legendary Actions"] : 0;
      }
      this.lair_actions_extra = obj.lair_actions_extra ? obj.lair_actions_extra : "";
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      level: this.level,
      resistances: this.resistances,
      res_lair: this.res_lair,
      // res_desc: this.res_desc,
      actions: this.actions,
      act_lair: this.act_lair,
      // act_desc: this.act_desc,
      lair_actions_extra: this.lair_actions_extra,
    };
  }

  copy(copyMe: Legendaries, ignore_level = false): void {
    if (!ignore_level) {
      this.true_id = copyMe.true_id;
      this.level = copyMe.level;
      this.resistances = copyMe.resistances;
      this.res_lair = copyMe.res_lair;
      // this.res_desc = copyMe.res_desc;
      this.actions = copyMe.actions;
      this.act_lair = copyMe.act_lair;
      // this.act_desc = copyMe.act_desc;
      this.lair_actions_extra = copyMe.lair_actions_extra;
    }
  }

  merge(copyMe: Legendaries): void {
    console.error("Not Implemented");
  }

  clone(): Legendaries {
    const new_obj = new Legendaries();
    new_obj.copy(this);
    return new_obj;
  }
}

export class AttributesTable {
  entries: Attributes[] = [];
  
  constructor(obj?: any) {
    if (obj) {
      this.entries = [];
      if (obj.entries) {
        obj.entries.forEach((entry: any) => {
          this.entries.push(new Attributes(entry));
        });
      }
    }
  }

  getEntry(level: number) {
    let entry = this.entries.find(o => o.level === level);
    if (!entry) {
      // Get the highest one that is below level.
      const max = Math.max(...this.entries.filter(o => o.level < level).map(o => o.level),0);
      entry = this.entries.find(o => o.level === max);
    }
    return entry;
  }

  toDBObj(): any {
    return {
      entries: this.entries.map(o => o.toDBObj()),
    };
  }

  copy(copyMe: AttributesTable): void {
    this.entries = copyMe.entries.map(o => o.clone());
  }

  clone(): AttributesTable {
    const new_obj = new AttributesTable();
    new_obj.copy(this);
    return new_obj;
  }

  get all_attributes() {
    return [
      "damage_immunities",
      "damage_resistances",
      "damage_vulnerabilities",
      "condition_immunities",
      "senses",
      "skill_profs",
      "save_profs",
      "speeds",
      "tool_profs",
      "languages"
    ];
  }

  get damage_immunities_unchanged() {
    if (this.entries.length > 1) {
      const damages = this.entries[0].damage_immunities;
      const extras = this.entries[0].extra_damage_immunities;
      const different = this.entries.filter(o => o.extra_damage_immunities !== extras || !common_util.listsMatch(damages, o.damage_immunities));
      return different.length === 0;
    }
    return true;
  }
  get damage_resistances_unchanged() {
    if (this.entries.length > 1) {
      const damages = this.entries[0].damage_resistances;
      const extras = this.entries[0].extra_damage_resistances;
      const different = this.entries.filter(o => o.extra_damage_resistances !== extras || !common_util.listsMatch(damages, o.damage_resistances));
      return different.length === 0;
    }
    return true;
  }
  get damage_vulnerabilities_unchanged() {
    if (this.entries.length > 1) {
      const damages = this.entries[0].damage_vulnerabilities;
      const extras = this.entries[0].extra_damage_vulnerabilities;
      const different = this.entries.filter(o => o.extra_damage_vulnerabilities !== extras || !common_util.listsMatch(damages, o.damage_vulnerabilities));
      return different.length === 0;
    }
    return true;
  }
  get condition_immunities_unchanged() {
    if (this.entries.length > 1) {
      const conditions = this.entries[0].condition_immunities;
      const different = this.entries.filter(o => !common_util.listsMatch(conditions, o.condition_immunities));
      return different.length === 0;
    }
    return true;
  }
  get senses_unchanged() {
    if (this.entries.length > 1) {
      const senses = this.entries[0].senses;
      const different = this.entries.filter(o => !common_util.objectsMatch(senses, o.senses));
      return different.length === 0;
    }
    return true;
  }
  get skill_profs_unchanged() {
    if (this.entries.length > 1) {
      const skills = this.entries[0].skill_profs;
      const different = this.entries.filter(o => !common_util.objectsMatch(skills, o.skill_profs));
      return different.length === 0;
    }
    return true;
  }
  get save_profs_unchanged() {
    if (this.entries.length > 1) {
      const saves = this.entries[0].save_profs;
      const different = this.entries.filter(o => !common_util.objectsMatch(saves, o.save_profs));
      return different.length === 0;
    }
    return true;
  }
  get speeds_unchanged() {
    if (this.entries.length > 1) {
      const speeds = this.entries[0].speeds;
      const different = this.entries.filter(o => !common_util.objectsMatch(speeds, o.speeds));
      return different.length === 0;
    }
    return true;
  }
  get tool_profs_unchanged() {
    if (this.entries.length > 1) {
      const tools = this.entries[0].tool_profs;
      const different = this.entries.filter(o => !common_util.listsMatch(tools, o.tool_profs));
      return different.length === 0;
    }
    return true;
  }
  get languages_unchanged() {
    if (this.entries.length > 1) {
      const languages = this.entries[0].languages;
      const different = this.entries.filter(o => languages === o.languages);
      return different.length === 0;
    }
    return true;
  }

  extrapolateEmptyFields() {
    let level_options = [...CREATURE_CRS];
    level_options = level_options.filter(o => this.entries.filter(o2 => `${o2.level}` === o).length === 0);
    const entry_levels = this.entries.map(o => o.level);
    const min = entry_levels.length === 0 ? 0 : Math.min(...entry_levels);
    const max = entry_levels.length === 0 ? 0 : Math.max(...entry_levels);
    const empty_entries = level_options.map(o => +o).filter(o => o > min && o < max);
    // Identify blocks of empty entries
    let use_empty_entries = [...empty_entries];
    const new_entries: Attributes[] = [];
    for (let i = 0; i < use_empty_entries.length; ++i) {
       
      const copy_level = Math.max(...entry_levels.filter(o => o < use_empty_entries[i]));
      const new_entry = this.entries.find(o => o.level === copy_level)?.clone()??new Attributes();
      new_entry.level = use_empty_entries[i];
      new_entries.push(new_entry);
    }
    let min_empty = Math.min(...use_empty_entries);
    let level_before = Math.max(...entry_levels.filter(o => o < min_empty));
    let level_after = Math.min(...entry_levels.filter(o => o > level_before));
    let before = this.entries.find(o => o.level === level_before);
    let after = this.entries.find(o => o.level === level_after);
    while (before && after) {
      debugger;
      // console.log(before);
      // console.log(after);
      
      // Go through each attribute and figure out what's different and determine an ideal way to transition between them
      // Condition and Damage Immunities we don't want to extrapolate. They will be granted or removed at the levels of the originals. 
      // Same for Vulnerabilities, Senses, Speeds, and Tool Profs.

      // Resistances we can extrapolate
      if (!common_util.listsMatch(before.damage_resistances, after.damage_resistances)) {
        const before_attrs = [...before.damage_resistances];
        let after_attrs = [...after.damage_resistances];
        const adding = after_attrs.filter(o => !before_attrs.includes(o));
        const removing = before_attrs.filter(o => !after_attrs.includes(o));
        // Decide levels to add/remove each
        const level_diff = level_after - level_before;
        const a_level_ratio = adding.length / level_diff;
        const r_level_ratio = removing.length / level_diff;
        let added = 0;
        let removed = 0;
        for (let i = 1; i < level_diff; ++i) {
          while (Math.floor(a_level_ratio * i) > added) {
            const adding_attr = after_attrs.find(o => !before_attrs.includes(o));
            if (adding_attr) {
              before_attrs.push(adding_attr);
              for (let j = i + level_before; j < level_after; ++j) {
                const entry = new_entries.find(o => o.level === j);
                if (entry) {
                  entry.damage_resistances.push(adding_attr);
                  added++;
                }
              }
            } else {
              console.error("Extrapolation error");
              debugger;
              break;
            }
          }
          while (Math.floor(r_level_ratio * i) > removed) {
             
            const removing_attr = before_attrs.find(o => !after_attrs.includes(o));
            if (removing_attr) {
              after_attrs = after_attrs.filter(o => o !== removing_attr);
              for (let j = i + level_before; j < level_after; ++j) {
                const entry = new_entries.find(o => o.level === j);
                if (entry) {
                  entry.damage_resistances = entry.damage_resistances.filter(o => o !== removing_attr);
                  removed++;
                }
              }
            } else {
              console.error("Extrapolation error");
              debugger;
              break;
            }
          }
        }
      }

      // Now Save Proficiencies
      if (!common_util.listsMatch(before.save_profs, after.save_profs)) {
        const before_attrs = [...before.save_profs];
        let after_attrs = [...after.save_profs];
        const adding = after_attrs.filter(o => !before_attrs.includes(o));
        const removing = before_attrs.filter(o => !after_attrs.includes(o));
        // Decide levels to add/remove each
        const level_diff = level_after - level_before;
        const a_level_ratio = adding.length / level_diff;
        const r_level_ratio = removing.length / level_diff;
        let added = 0;
        let removed = 0;
        for (let i = 1; i < level_diff; ++i) {
          while (Math.floor(a_level_ratio * i) > added) {
            const adding_attr = after_attrs.find(o => !before_attrs.includes(o));
            if (adding_attr) {
              before_attrs.push(adding_attr);
              for (let j = i + level_before; j < level_after; ++j) {
                const entry = new_entries.find(o => o.level === j);
                if (entry) {
                  entry.save_profs.push(adding_attr);
                  added++;
                }
              }
            } else {
              console.error("Extrapolation error");
              debugger;
              break;
            }
          }
          while (Math.floor(r_level_ratio * i) > removed) {
             
            const removing_attr = before_attrs.find(o => !after_attrs.includes(o));
            if (removing_attr) {
              after_attrs = after_attrs.filter(o => o !== removing_attr);
              for (let j = i + level_before; j < level_after; ++j) {
                const entry = new_entries.find(o => o.level === j);
                if (entry) {
                  entry.save_profs = entry.save_profs.filter(o => o !== removing_attr);
                  removed++;
                }
              }
            } else {
              console.error("Extrapolation error");
              debugger;
              break;
            }
          }
        }
      }

      // Now Skill Proficiencies
      if (!common_util.objectsMatch(before.skill_profs, after.skill_profs)) {
        // This one is more complicated
        const before_attrs = Object.keys(before.skill_profs);
        let after_attrs = Object.keys(after.skill_profs);
        const increased_attrs: string[] = [];

        const adding = after_attrs.filter(o => !before_attrs.includes(o));
        const removing = before_attrs.filter(o => !after_attrs.includes(o));
         
        const increasing = after_attrs.filter(o => before && after && after.skill_profs[o] === 2 && (!before.skill_profs[o] || before.skill_profs[o] < 2));
        // Decide levels to add/remove each
        const level_diff = level_after - level_before;
        const a_level_ratio = adding.length / level_diff;
        const r_level_ratio = removing.length / level_diff;
        const i_level_ratio = increasing.length / level_diff;
        let added = 0;
        let removed = 0;
        let increased = 0;
        for (let i = 1; i < level_diff; ++i) {
          while (Math.floor(a_level_ratio * i) > added) {
            const adding_attr = after_attrs.find(o => !before_attrs.includes(o));
            if (adding_attr) {
              before_attrs.push(adding_attr);
              for (let j = i + level_before; j < level_after; ++j) {
                const entry = new_entries.find(o => o.level === j);
                if (entry) {
                  entry.skill_profs[adding_attr] = 1;
                  added++;
                }
              }
            } else {
              console.error("Extrapolation error");
              debugger;
              break;
            }
          }
          while (Math.floor(r_level_ratio * i) > removed) {
             
            const removing_attr = before_attrs.find(o => !after_attrs.includes(o));
            if (removing_attr) {
              after_attrs = after_attrs.filter(o => o !== removing_attr);
              for (let j = i + level_before; j < level_after; ++j) {
                const entry = new_entries.find(o => o.level === j);
                if (entry) {
                  delete entry.skill_profs[removing_attr];
                  removed++;
                }
              }
            } else {
              console.error("Extrapolation error");
              debugger;
              break;
            }
          }
          while (Math.floor(i_level_ratio * i) > increased) {
            const increasing_attr = increasing.find(o => before_attrs.includes(o) && !increased_attrs.includes(o));
            if (increasing_attr) {
              increased_attrs.push(increasing_attr);
              for (let j = i + level_before; j < level_after; ++j) {
                const entry = new_entries.find(o => o.level === j);
                if (entry) {
                  entry.skill_profs[increasing_attr] = 2;
                  increased++;
                }
              }
            } else {
              // It may try to increase it to Expert when it hasn't added it as Trained yet
              // Worst case, this method should make it wait one level
              break;
            }
          }
        }
      }
       
      use_empty_entries = use_empty_entries.filter(o => o > level_after);
      min_empty = Math.min(...use_empty_entries); 
      level_before = Math.max(...entry_levels.filter(o => o < min_empty)); 
      level_after = Math.min(...entry_levels.filter(o => o > level_before)); 
      before = this.entries.find(o => o.level === level_before); 
      after = this.entries.find(o => o.level === level_after);
    }
    this.entries.push(...new_entries);
  }
}

export class Attributes { 
  true_id = "";
  level = 0;
  damage_immunities: DamageType[] = []; 
  damage_resistances: DamageType[] = [];
  damage_vulnerabilities: DamageType[] = [];
  extra_damage_immunities = "";
  extra_damage_resistances = "";
  extra_damage_vulnerabilities = "";
  condition_immunities: string[] = [];
  senses: { [sense_name: string]: number } = {};
  skill_profs: { [skill_id: string]: number } = {};
  save_profs: string[] = [];
  speeds: { [speed_type: string]: number } = {};
  hover = false;
  tool_profs: string[] = [];
  languages = "";
  
  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.level = obj.level ? obj.level : 0;
      this.damage_immunities = obj.damage_immunities ? obj.damage_immunities : [];
      this.damage_resistances = obj.damage_resistances ? obj.damage_resistances : [];
      this.damage_vulnerabilities = obj.damage_vulnerabilities ? obj.damage_vulnerabilities : [];
      this.extra_damage_immunities = obj.extra_damage_immunities ? obj.extra_damage_immunities : "";
      this.extra_damage_resistances = obj.extra_damage_resistances ? obj.extra_damage_resistances : "";
      this.extra_damage_vulnerabilities = obj.extra_damage_vulnerabilities ? obj.extra_damage_vulnerabilities : "";
      this.condition_immunities = obj.condition_immunities ? obj.condition_immunities : [];
      this.senses = obj.senses ? obj.senses : {};
      this.skill_profs = obj.skill_profs ? obj.skill_profs : {};
      this.save_profs = obj.save_profs ? obj.save_profs : {};
      this.speeds = obj.speeds ? obj.speeds : {};
      this.hover = obj.hover ? obj.hover : false;
      this.tool_profs = obj.tool_profs ? obj.tool_profs : [];
      this.languages = obj.languages ? obj.languages : "";
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      level: this.level,
      damage_immunities: this.damage_immunities,
      damage_resistances: this.damage_resistances,
      damage_vulnerabilities: this.damage_vulnerabilities,
      extra_damage_immunities: this.extra_damage_immunities,
      extra_damage_resistances: this.extra_damage_resistances,
      extra_damage_vulnerabilities: this.extra_damage_vulnerabilities,
      condition_immunities: this.condition_immunities,
      senses: this.senses,
      skill_profs: this.skill_profs,
      save_profs: this.save_profs,
      speeds: this.speeds,
      hover: this.hover,
      tool_profs: this.tool_profs,
      languages: this.languages,
    };
  }

  copy(copyMe: Attributes, ignore_level = false): void {
    if (!ignore_level) {
      this.true_id = copyMe.true_id;
      this.level = copyMe.level;
    }
    this.damage_immunities = [...copyMe.damage_immunities];
    this.damage_resistances = [...copyMe.damage_resistances];
    this.damage_vulnerabilities = [...copyMe.damage_vulnerabilities];
    this.extra_damage_immunities = copyMe.extra_damage_immunities;
    this.extra_damage_resistances = copyMe.extra_damage_resistances;
    this.extra_damage_vulnerabilities = copyMe.extra_damage_vulnerabilities;
    this.condition_immunities = [...copyMe.condition_immunities];
    this.senses = {...copyMe.senses};
    this.skill_profs = {...copyMe.skill_profs};
    this.save_profs = [...copyMe.save_profs];
    this.speeds = {...copyMe.speeds};
    this.hover = copyMe.hover;
    this.tool_profs = [...copyMe.tool_profs];
    this.languages = copyMe.languages;
  }

  merge(copyMe: Attributes): void {
    this.damage_immunities = [...this.damage_immunities,...copyMe.damage_immunities.filter(o => !this.damage_immunities.includes(o))];
    this.damage_resistances = [...this.damage_resistances,...copyMe.damage_resistances.filter(o => !this.damage_resistances.includes(o))];
    this.damage_vulnerabilities = [...this.damage_vulnerabilities,...copyMe.damage_vulnerabilities.filter(o => !this.damage_immunities.includes(o))];
    this.extra_damage_immunities = this.extra_damage_immunities.length === 0 ? copyMe.extra_damage_immunities : this.extra_damage_immunities;
    this.extra_damage_resistances = this.extra_damage_resistances.length === 0 ? copyMe.extra_damage_resistances : this.extra_damage_resistances;
    this.extra_damage_vulnerabilities = this.extra_damage_vulnerabilities.length === 0 ? copyMe.extra_damage_vulnerabilities : this.extra_damage_vulnerabilities;
    this.condition_immunities = [...this.condition_immunities,...copyMe.condition_immunities.filter(o => !this.condition_immunities.includes(o))];
    for (const key of Object.keys(copyMe.senses)) {
      if (!this.senses[key]) {
        this.senses[key] = copyMe.senses[key];
      }
    }
    for (const key of Object.keys(copyMe.skill_profs)) {
      if (!this.skill_profs[key]) {
        this.skill_profs[key] = copyMe.skill_profs[key];
      }
    }
    this.save_profs = [...this.save_profs,...copyMe.save_profs.filter(o => !this.save_profs.includes(o))];
    for (const key of Object.keys(copyMe.speeds)) {
      if (!this.speeds[key]) {
        this.speeds[key] = copyMe.speeds[key];
      }
    }
    this.hover = this.hover || copyMe.hover;
    this.tool_profs = [...this.tool_profs,...copyMe.tool_profs.filter(o => !this.tool_profs.includes(o))];
    this.languages = this.languages.length === 0 ? copyMe.languages : this.languages;
  }

  clone(): Attributes {
    const new_obj = new Attributes();
    new_obj.copy(this);
    return new_obj;
  }
  
  get speed_string() {
    let str = "";
    for (const speed of Object.keys(this.speeds)) {
      const num = this.speeds[speed];
      if (num && num > 0) {
        if (str.length > 0) {
          str += ", ";
        }
        str += `${speed} ${num} ft.`;
        if (speed === "fly" && this.hover) {
          str += " (hover)"
        }
      }
    }
    return str;
  }
  
  get saving_throws_string() {
    let str = "";
    for (const ability_score of this.save_profs) {
      if (str.length > 0) {
        str += ", ";
      }
      str += `${ability_score}`;
    }
    return str;
  }
  
  get skills_string() {
    let str = "";
    for (const skill_id of Object.keys(this.skill_profs)) {
      const skill = SKILLS.find(o => o._id === skill_id);
      const prof = this.skill_profs[skill_id];
      if (skill && prof >= 1) {
        if (str.length > 0) {
          str += ", ";
        }
        str += `${skill.name}${prof > 1 ? " (Expert)" : ""}`;
      }
    }
    return str;
  }
  
  get immunities_string() {
    return this.damage_immunities.join(", ") + ((this.damage_immunities.length > 0 && this.extra_damage_immunities.length > 0) ? "; " : "") + this.extra_damage_immunities;
  }
  
  get resistances_string() {
    return this.damage_resistances.join(", ") + ((this.damage_resistances.length > 0 && this.extra_damage_resistances.length > 0) ? "; " : "") + this.extra_damage_resistances;
  }
  
  get vulnerabilities_string() {
    return this.damage_vulnerabilities.join(", ") + ((this.damage_vulnerabilities.length > 0 && this.extra_damage_vulnerabilities.length > 0) ? "; " : "") + this.extra_damage_vulnerabilities;
  }
  
  get condition_immunities_string() {
    return this.condition_immunities.join(", ");
  }
  
  get senses_string() {
    return Object.keys(this.senses).map(sense_name => {
      return sense_name + ": " + this.senses[sense_name] + " ft.";
    }).filter(o => o !== "").join(", ");
  }
  
  get tools_string() {
    return this.tool_profs.join(", ");
  }
}

export class SpellcastingTable {
  entries: SpellcastingEntry[] = [];
  
  constructor(obj?: any) {
    if (obj) {
      this.entries = [];
      if (obj.entries) {
        obj.entries.forEach((entry: any) => {
          this.entries.push(new SpellcastingEntry(entry));
        });
      }
    }
  }

  getEntry(level: number) {
    let entry = this.entries.find(o => o.level === level);
    if (!entry) {
      // Get the highest one that is below level.
      const max = Math.max(...this.entries.filter(o => o.level < level).map(o => o.level),0);
      entry = this.entries.find(o => o.level === max);
    }
    return entry;
  }

  get spell_levels() {
    return common_util.unique_array(this.entries.flatMap(o => o.spell_levels));
  }

  get spell_ids() {
    return common_util.unique_array(this.entries.flatMap(o => o.spell_ids));
  }

  toDBObj(): any {
    return {
      entries: this.entries.map(o => o.toDBObj()),
    };
  }

  copy(copyMe: SpellcastingTable): void {
    this.entries = copyMe.entries.map(o => o.clone());
  }

  clone(): SpellcastingTable {
    const new_obj = new SpellcastingTable();
    new_obj.copy(this);
    return new_obj;
  }

  // extrapolateEmptyFields() {
  //   let level_options = [...CREATURE_CRS];
  //   level_options = level_options.filter(o => this.entries.filter(o2 => `${o2.level}` === o).length === 0);
  //   const entry_levels = this.entries.map(o => o.level);
  //   const min = entry_levels.length === 0 ? 0 : Math.min(...entry_levels);
  //   const max = entry_levels.length === 0 ? 0 : Math.max(...entry_levels);
  //   const empty_entries = level_options.map(o => +o).filter(o => o > min && o < max);
  //   // Identify blocks of empty entries
  //   let use_empty_entries = [...empty_entries];
  //   const new_entries: SpellcastingEntry[] = [];
  //   for (let i = 0; i < use_empty_entries.length; ++i) {
  //     // eslint-disable-next-line
  //     const copy_level = Math.max(...entry_levels.filter(o => o < use_empty_entries[i]));
  //     const new_entry = this.entries.find(o => o.level === copy_level)?.clone()??new SpellcastingEntry();
  //     new_entry.level = use_empty_entries[i];
  //     new_entries.push(new_entry);
  //   }
  //   let min_empty = Math.min(...use_empty_entries);
  //   let level_before = Math.max(...entry_levels.filter(o => o < min_empty));
  //   let level_after = Math.min(...entry_levels.filter(o => o > level_before));
  //   let before = this.entries.find(o => o.level === level_before);
  //   let after = this.entries.find(o => o.level === level_after);
  //   const spells = api.smart_hash.spell as Spell[];
  //   while (before && after) {
  //     debugger;
  //     // console.log(before);
  //     // console.log(after);
      
  //     // There shouldn't be any spells removed.
  //     // Spells may be added, and castings can be increased, or they can be changed to At Will
  //     // If it uses slots then they can be ignored. They're part of resources table.
  //     const after_spells = after.spells;
  //     const before_spells = before.spells;
  //     const missing_spell_ids = after_spells.map(o => o.spell_id).filter(o => before_spells.filter(o2 => o2.spell_id === o).length === 0);
  //     let before_max_level = Math.max(...before_spells.map(o => o.spell_level));
  //     let after_max_level = Math.max(...after_spells.map(o => o.spell_level));

  //     // Set missing spells on before, will be removed after
  //     for (const spell_id of missing_spell_ids) {
  //       const spell = spells.find(o => o._id === spell_id || (o.variant_ids.includes(spell_id) && o.is_dominant));
  //       if (spell) {
  //         before_spells.push({
  //           spell_id: spell._id,
  //           spell_level: spell.level,
  //           cast_type: "X/Day",
  //           x: 0
  //         });
  //       }
  //     }

  //     const max_level_diff = after_max_level - before_max_level;
  //     const cr_diff = level_after - level_before;
  //     if (max_level_diff > 0) {
  //       const m_ratio = max_level_diff / cr_diff;
  //       const max_level_for_cr: { [cr: number]: number } = {};
  //       max_level_for_cr[level_before] = before_max_level;
  //       max_level_for_cr[level_after] = after_max_level;
  //       for (let i = 1; i < cr_diff; ++i) {
  //         const cr = level_before + i;
  //         max_level_for_cr[cr] = before_max_level;
  //       }

  //       for (let i = 1; i < cr_diff; ++i) {
  //         const cr = level_before + i;
  //         const new_entry = new_entries.find(o => o.level === cr);
  //         if (new_entry) {
  //           const new_max_level = before_max_level + Math.floor(m_ratio * i);
  //           if (new_max_level > max_level_for_cr[cr]) {
  //             for (let j = cr; j < level_after; ++j) {
  //               max_level_for_cr[j] = new_max_level;
  //             }
  //           }

  //           const spells_for_cr = before_spells.filter(o => o.spell_level <= new_max_level).map(o => { return {...o}; });
  //           for (const spell_new of spells_for_cr) {
  //             const spell_after = after_spells.find(o => o.spell_id === spell_new.spell_id);
  //             const spell_before = before_spells.find(o => o.spell_id === spell_new.spell_id);
  //             if (spell_after && spell_before) {
  //               if (spell_after.cast_type === spell_new.cast_type) {
  //                 if (spell_after.cast_type === "X/Day") {
  //                   const x_diff = spell_after.x - spell_before.x;
  //                   const x_ratio = x_diff / cr_diff;
  //                   const x_new = spell_before.x + Math.floor(x_ratio * i);
  //                   spell_new.x = x_new;
  //                 } else {
  //                   // Don't worry about it, regardless of what type, it's fine
  //                 }
  //               } else if (spell_after.cast_type === "At Will" && spell_new.cast_type === "X/Day") {
  //                 // At Will is treated the same as 5/Day
  //                 const x_diff = 5 - spell_before.x;
  //                 const x_ratio = x_diff / cr_diff;
  //                 const x_new = spell_before.x + Math.floor(x_ratio * i);
  //                 spell_new.x = x_new;
  //                 // We don't need to worry about it getting past 4/Day because the math makes it so 5/Day will happen at level_after
  //               } else {
  //                 spell_new.cast_type = spell_after.cast_type;
  //               }
  //             }
  //           }
  //           new_entry.spells = spells_for_cr;
  //         }
  //       }
  //     } else {
  //       for (let i = 1; i < cr_diff; ++i) {
  //         const cr = level_before + i;
  //         const new_entry = new_entries.find(o => o.level === cr);
  //         if (new_entry) {
  //           const spells_for_cr = before_spells.map(o => { return {...o}; })
  //           for (const spell_new of spells_for_cr) {
  //             const spell_after = after_spells.find(o => o.spell_id === spell_new.spell_id);
  //             const spell_before = before_spells.find(o => o.spell_id === spell_new.spell_id);
  //             if (spell_after && spell_before) {
  //               if (spell_after.cast_type === spell_new.cast_type) {
  //                 if (spell_after.cast_type === "X/Day") {
  //                   const x_diff = spell_after.x - spell_before.x;
  //                   const x_ratio = x_diff / cr_diff;
  //                   const x_new = spell_before.x + Math.floor(x_ratio * i);
  //                   spell_new.x = x_new;
  //                 } else {
  //                   // Don't worry about it, regardless of what type, it's fine
  //                 }
  //               } else if (spell_after.cast_type === "At Will" && spell_new.cast_type === "X/Day") {
  //                 // At Will is treated the same as 5/Day
  //                 const x_diff = 5 - spell_before.x;
  //                 const x_ratio = x_diff / cr_diff;
  //                 const x_new = spell_before.x + Math.floor(x_ratio * i);
  //                 spell_new.x = x_new;
  //                 // We don't need to worry about it getting past 4/Day because the math makes it so 5/Day will happen at level_after
  //               } else {
  //                 spell_new.cast_type = spell_after.cast_type;
  //               }
  //             }
  //           }
  //           new_entry.spells = spells_for_cr;
  //         }
  //       }
  //     }
  //     // eslint-disable-next-line
  //     use_empty_entries = use_empty_entries.filter(o => o > level_after);
  //     min_empty = Math.min(...use_empty_entries);// eslint-disable-next-line
  //     level_before = Math.max(...entry_levels.filter(o => o < min_empty));// eslint-disable-next-line
  //     level_after = Math.min(...entry_levels.filter(o => o > level_before));// eslint-disable-next-line
  //     before = this.entries.find(o => o.level === level_before);// eslint-disable-next-line
  //     after = this.entries.find(o => o.level === level_after);
  //   }
  //   this.entries.push(...new_entries);
  //   for (const entry of this.entries) {
  //     entry.spells = entry.spells.filter(o => o.cast_type !== "X/Day" || o.x > 0);
  //   }
  // }
}

export class SpellcastingEntry { 
  level = 0;
  description = "";
  spells: iCreatureSpell[] = [];
  
  constructor(obj?: any) {
    if (obj) {
      this.level = obj.level ? obj.level : 0;
      this.description = obj.description ? obj.description : "";
      this.spells = [];
      if (obj.spells) {
        for (const s of obj.spells) {
          if (this.spells.filter(o => o.spell_id === s.spell_id).length === 0) {
            this.spells.push(s);
          }
        }
      }
    }
  }

  get spell_levels() {
    return common_util.unique_array(this.spells.map(o => o.spell_level));
  }

  get spell_ids() {
    return this.spells.map(o => o.spell_id);
  }

  get spells_by_x() {
    const x_day_spells = this.spells.filter(o => o.cast_type === "X/Day");
    const spells_by_x: { [x: number]: iCreatureSpell[] } = {};
    for (const x_day_spell of x_day_spells) {
      const x = x_day_spell.x;
      if (x) {
        if (!spells_by_x[x]) {
          spells_by_x[x] = [];
        }
        spells_by_x[x].push(x_day_spell);
      }
    }
    return spells_by_x;
  }
  
  setSpells(spells: { [level: number]: string[] }, mapping: { [new_id: string]: string }) {
    const new_spells: { spell_level: number, spell_id: string, cast_type: "Slot" | "At Will" | "X/Day" | "Ritual", x: number }[] = [];
    const spell_levels = Object.keys(spells).map(o => +o);
    for (const spell_level of spell_levels) {
      const spell_ids = spells[spell_level];
      for (const spell_id of spell_ids) {
        if (mapping[spell_id]) {
          const old_spell = this.spells.find(o => o.spell_id === mapping[spell_id]);
          if (old_spell) {
            old_spell.spell_id = spell_id;
            new_spells.push(old_spell);
          } else {
            new_spells.push({ spell_level, spell_id, cast_type: spell_level === 0 ? "At Will" : "Slot", x: 0 });
          }
        } else {
          const old_spell = this.spells.find(o => o.spell_id === spell_id);
          if (old_spell) {
            new_spells.push(old_spell);
          } else {
            new_spells.push({ spell_level, spell_id, cast_type: spell_level === 0 ? "At Will" : "Slot", x: 0 });
          }
        }
      }
    }
    this.spells = new_spells;
  }

  toDBObj(): any {
    return {
      level: this.level,
      description: this.description,
      spells: this.spells,
    };
  }

  copy(copyMe: SpellcastingEntry): void {
    this.level = copyMe.level;
    this.description = copyMe.description;
    this.spells = copyMe.spells.map(o => { return {...o}; });
  }

  clone(): SpellcastingEntry {
    const new_obj = new SpellcastingEntry();
    new_obj.copy(this);
    return new_obj;
  }
}

export interface iCreatureSpell { 
  spell_level: number;
  cast_level?: number;
  extra_text?: string;
  spell_id: string;
  cast_type: "Slot" | "At Will" | "X/Day" | "Ritual";
  x: number;
}